import { ActionsList } from "../../models";

export const ACTIONS_FILES_LIST: ActionsList[] = [
    {
        id: "add_to_category",
        name: "Добавить в категорию",
        action: "ADD_FILE_TO_CATEGORY"
    },
    {
        id: "download_selected",
        name: "Скачать выбранное",
        action: "DOWNLOAD_SELECT_FILE"
    },
    {
        id: "delete_selected",
        name: "Удалить выбранное",
        action: "ORGS_FILES_DELETE"
    },
    
]